// The timezone is stable for the session, so resolve it once at module load
// rather than on every render. Shared so every discoverability query sends the
// identical value — DiscoverabilityView and DiscoverabilityKPIs must build
// byte-identical KPI query args to share one RTK Query cache entry.
export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
